var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 6.09375H13.5938V5.78125C13.5938 3.79688 11.9844 2.1875 10 2.1875C8.01562 2.1875 6.40625 3.79688 6.40625 5.78125V6.09375H3.75C3.4043 6.09375 3.125 6.37305 3.125 6.71875V17.1875C3.125 17.5332 3.4043 17.8125 3.75 17.8125H16.25C16.5957 17.8125 16.875 17.5332 16.875 17.1875V6.71875C16.875 6.37305 16.5957 6.09375 16.25 6.09375ZM12.1875 6.09375H7.8125V5.78125C7.8125 4.57227 8.79102 3.59375 10 3.59375C11.209 3.59375 12.1875 4.57227 12.1875 5.78125V6.09375Z",
    fill: "black",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarCart);
export default __webpack_public_path__ + "static/media/sidebar-cart.04f056f410b03c4086ca44bf3cc93884.svg";
export { ForwardRef as ReactComponent };